import { create } from 'zustand';
import type { User } from '@typings/index';

interface AuthState {
    user: User | null;
    loading: boolean;
    error: string | null;

    setUser: (user: User | null) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
    logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    loading: true,
    error: null,

    setUser: (user) => set({ user, loading: false, error: null }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error, loading: false }),
    logout: () => set({ user: null, loading: false, error: null }),
}));
